declare const cordova: any;
import PlatformHelper from 'web-app/helpers/platform-helper';
import ENV from 'web-app/config/environment';

export const getBaseUrl = () => {
    const baseUrl = window.location.href.split('#')[0];
    return baseUrl.split('?')[0];
};

// Would usually take the output from 'generateUrl'.
export const makeCallbackUrl = (path: string) => {
    if (PlatformHelper.isMobileApp()) {
        return `${customUrlScheme}://${path.replace('#/', '')}`;
    } else {
        return `${getBaseUrl()}${path}`;
    }
};

// Would usually take the output from 'generateUrl'.
// Assumes that if the user is on a touch device we want to link to the native app
export const makeDeepLinkUrl = (path: string) => {
    if (getIsTouchDevice()) {
        return `${customUrlScheme}://${path.replace('#/', '')}`;
    } else {
        return `${getBaseUrl()}${path}`;
    }
};

export const redirectTo = (url: string) => {
    if (PlatformHelper.isMobileApp()) {
        cordova.InAppBrowser.open(url, '_system', 'location=no');
    } else {
        window.location.href = url;
    }
};

declare global {
    interface Window {
        [key: string]: any;
        DocumentTouch?: any;
    }
}

const getIsTouchDevice = () => {
    // Not 100% reliable in old browsers/devices but it's used in this library https://modernizr.com/
    // that currently has 24k stars on Github.
    // Mentioned in a comment here:
    // https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript/4819886#4819886
    // with 625 UPs currently :-)
    if ('ontouchstart' in window || window.DocumentTouch) {
        return true;
    }
    const query = [
        // The string representations of touch-media-queries
        '(touch-enabled)',
        '(-webkit-touch-enabled)',
        '(-moz-touch-enabled)',
        '(-o-touch-enabled)',
        '(-ms-touch-enabled)',
    ].join(',');
    return window.matchMedia(query).matches;
};

export const customUrlScheme = ENV.APP.customUrlScheme || 'com.famly.famlyapp';
